import Axios from "axios";
import React, { ReactEventHandler, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as DonorServiceApi from "../DonorServiceApi";
import "./Congratulations.css";
import DonationNavBar from "components/layout/navigation/DonationNavBar/DonationNavBar";
import DonationNavBarMobile from "components/layout/navigation/DonationNavBarMobile/DonationNavBarMobile";
import { useAppSelector } from "store/hooks";
import { useDispatch } from "react-redux";
import ThankYouModal from "../ThankYouModal/ThankYouModal";
import {
  updateShowThankYou,
  updateShowThankYouScreen,
} from "store/ui/thankYouScreen/thankYouScreen.slice";
import { updateShowError } from "store/ui/errorPopupScreen/errorPopupScreen.slice";

export const Congratulations = () => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const showThankYou = useAppSelector(
    (state) => state.showThankYou.showThankYouScreen
  );
  let key = "";

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  const params: any = useQuery();

  const app = Axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  useEffect(() => {
    const eventTitle = new URLSearchParams(window.location.search).get(
      "eventTitle"
    );
    const amount = new URLSearchParams(window.location.search).get("amount");

    app
      .post("/auth/securityHole", {
        userId: params.get("userId"),
      })
      .then(function (response) {
        key = response.data.accessToken;
        app.interceptors.request.use(async (config: any) => {
          console.log("key");
          console.log(key);
          config.headers.Authorization = "Bearer " + key;
          return config;
        });

        const Id = params.get("donorId");
        app
          .post("/donor/setDonationStatus", {
            donation_id: Id,
            donation_status: "success",
          })
          .then((r) => {
            console.log(r.data)
            dispatch(updateShowThankYou({
              showThankYouScreen: true,
              eventTitle: eventTitle || undefined,
              donationAmount: amount!.substring(0, amount!.length - 2) + "."  + amount!.substring(amount!.length - 2),
            }));
          })
          .catch((err) => {
            console.log(err)
            dispatch(updateShowError({
            showErrorPopup: true,
            errorMessage: err.message || 'Unknown error'
        }));
          });
      })
      .catch(function (error) {
        console.log(error);
        dispatch(updateShowError({
          showErrorPopup: true,
          errorMessage: error.message || 'Unknown error'
        }));
      });
  }, [params]);

  useEffect(() => {
    const isMobileDevice = /Mobi/i.test(window.navigator.userAgent);
    setIsMobile(isMobileDevice);
  }, []);

  return (
    <div className="container">
      {isMobile ? <DonationNavBarMobile /> : <DonationNavBar />}

      {showThankYou ? <ThankYouModal /> : null}

      <p>You may now close the browser if on mobile.</p>
    </div>
  );
};
